var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({staticClass:"btn",on:{"click":function($event){return _vm.emitClick($event)}}},'v-btn',_vm.attrs$,false),_vm.listeners$),[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }